import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingHomeSystemsPage: FlowPage = {
  slug: () => 'home-systems',
  title: () => 'Have you replaced any of these systems?',
  isEnabled,
  autoAdvance: () => true,
  questions: () => [
    {
      key: 'home.home_systems',
      type: 'multi_select',
      options: [
        {
          label: 'HVAC',
          value: 'hvac',
        },
        {
          label: 'Roof',
          value: 'roof',
        },
        {
          label: 'Electrical',
          value: 'electrical',
        },
        {
          label: 'Plumbing',
          value: 'plumbing',
        },
      ],
      showNoneOfTheAbove: true,
    },
  ],
};

export default longboardingHomeSystemsPage;
